import React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

const FLOWERS = ['🌼', '🌷', '🌻', '🌸', '🪻', '🌺'];

function StudentGardenCard({ student, criteria }) {
  const counts = student?.criteria_counts || {};
  return (
    <Box sx={{ borderRadius: 4, border: '3px solid #b7df74',
      background: 'linear-gradient(180deg, #f8ffe9 0%, #e8f8cf 100%)',
      boxShadow: '0 5px 0 rgba(63,136,35,0.16)', p: { xs: 1.5, sm: 2 } }}>
      <Typography sx={{ color: '#245521', fontWeight: 1000, fontSize: { xs: 21, sm: 24 }, overflowWrap: 'anywhere' }}>
        {student?.display_name || 'Öğrenci'}
      </Typography>
      <Typography sx={{ color: '#92400e', fontWeight: 900, mt: 0.5 }}>
        ⭐ {Number(student?.lifetime_stars || 0)} yıldız
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 1, mt: 1.5 }}>
        {criteria.map((criterion, index) => (
          <Box key={criterion.id} sx={{ display: 'flex', alignItems: 'center', gap: 0.7,
            p: 1, borderRadius: 2, bgcolor: 'rgba(255,255,255,0.85)', minWidth: 0 }}>
            <Box aria-hidden="true" sx={{ fontSize: 31, lineHeight: 1 }}>{FLOWERS[index % FLOWERS.length]}</Box>
            <Box sx={{ minWidth: 0 }}>
              <Typography sx={{ fontSize: 12, fontWeight: 800, lineHeight: 1.2, overflowWrap: 'anywhere' }}>{criterion.name}</Typography>
              <Typography sx={{ color: '#92400e', fontWeight: 900 }}>⭐ {Number(counts[String(criterion.id)] || 0)}</Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default function StarGardenReadOnlyDialog({ open, onClose, loading, error, garden }) {
  const classCode = garden?.class?.code;
  const criteria = garden?.criteria || [];
  const students = garden?.students || [];
  return (
    <Dialog fullScreen open={open} onClose={onClose} aria-labelledby="star-garden-dialog-title">
      <Box sx={{ minHeight: '100%', bgcolor: '#f7ffe9' }}>
        <DialogTitle id="star-garden-dialog-title" sx={{ bgcolor: '#3f8c23', color: '#fff', minHeight: 78,
          display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1.5 }}>
          <Box>
            <Typography component="div" sx={{ fontSize: { xs: 24, sm: 32 }, fontWeight: 1000 }}>
              {classCode ? `${classCode} Sınıfının Yıldız Bahçesi` : 'Yıldız Bahçemiz'}
            </Typography>
            <Typography component="div" sx={{ fontWeight: 800, color: '#ecfccb' }}>Salt okunur sınıf görünümü</Typography>
          </Box>
          <IconButton aria-label="Yıldız Bahçemizi kapat" onClick={onClose} sx={{ color: '#fff' }}><CloseRoundedIcon /></IconButton>
        </DialogTitle>
        <DialogContent sx={{ maxWidth: 1540, width: '100%', mx: 'auto', px: { xs: 1.4, sm: 2.5, md: 4 }, py: { xs: 2, sm: 3 } }}>
          {loading && <Box sx={{ minHeight: 320, display: 'grid', placeItems: 'center' }}><CircularProgress size={54} /></Box>}
          {!loading && error && <Box role="alert" sx={{ mt: 4, p: 2, bgcolor: '#fff7ed', color: '#9a3412' }}>{error}</Box>}
          {!loading && !error && garden && (
            <>
              <Typography sx={{ color: '#92400e', fontSize: { xs: 25, sm: 33 }, fontWeight: 1000,
                textAlign: 'center', mb: 3 }}>
                Birlikte {Number(garden.total_stars || 0)} yıldız biriktirdik! 🌼
              </Typography>
              {students.length ? (
                <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 250px), 1fr))', gap: 2 }}>
                  {students.map((student) => <StudentGardenCard key={student.id} student={student} criteria={criteria} />)}
                </Box>
              ) : <Typography sx={{ textAlign: 'center', mt: 5 }}>Bu sınıfta gösterilecek öğrenci bulunmuyor.</Typography>}
            </>
          )}
        </DialogContent>
      </Box>
    </Dialog>
  );
}
